import request from '@/utils/request'

/**
 * 分页查询IP黑名单
 * @param {Object} params 查询参数
 * @param {number} params.pageNum 当前页
 * @param {number} params.pageSize 每页大小
 * @param {string} params.ipAddress IP地址（可选，模糊匹配）
 */
export function reqIpBlacklistPage(params) {
    return request({
        url: '/system/sysIpBlacklist/page',
        method: 'get',
        params
    })
}

/**
 * 新增封禁IP
 * @param {Object} data { ipAddress, reason }
 */
export function reqIpBlacklistAdd(data) {
    return request({
        url: '/system/sysIpBlacklist/add',
        method: 'post',
        data
    })
}

/**
 * 解封（删除黑名单记录）
 * @param {number} id 主键
 */
export function reqIpBlacklistDelete(id) {
    return request({
        url: `/system/sysIpBlacklist/delete/${id}`,
        method: 'delete'
    })
}
